import Reveal from '@/components/base/Reveal';
import { topicTags } from '@/mocks/home';
import SectionHeading from './SectionHeading';

interface TagWallProps {
  notify: (msg: string) => void;
}

const toneClass: Record<string, string> = {
  primary: 'border-primary-200 bg-primary-100 text-primary-700 hover:bg-primary-500 hover:text-background-50',
  secondary: 'border-secondary-200 bg-secondary-100 text-secondary-800 hover:bg-secondary-600 hover:text-background-50',
  accent: 'border-accent-200 bg-accent-100 text-accent-900 hover:bg-accent-500 hover:text-foreground-950',
};

const sizeClass: Record<string, string> = {
  lg: 'px-5 py-3 text-base font-medium',
  md: 'px-4 py-2.5 text-sm',
  sm: 'px-3.5 py-2 text-xs',
};

export default function TagWall({ notify }: TagWallProps) {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <SectionHeading
            kicker="话题标签墙"
            icon="ri-hashtag"
            title="内容单元 · 话题标签墙"
            desc="每一个标签背后都是一类可下载的资源单元，标签越大代表当前热度越高，点选即可跳到对应合集。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 rounded-xl border border-background-200 bg-background-100 p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-3">
              {topicTags.map((tag) => (
                <button
                  key={tag.name}
                  type="button"
                  onClick={() => notify(`已筛选话题：${tag.name}`)}
                  className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border transition-colors ${toneClass[tag.tone]} ${sizeClass[tag.size]}`}
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center opacity-70">
                    <i className="ri-hashtag"></i>
                  </span>
                  {tag.name}
                  <span className="text-[11px] opacity-70">{tag.count}</span>
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={140}>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
            <div className="rounded-xl border border-primary-200 bg-primary-50 p-5">
              <div className="flex items-center gap-2 text-xs text-primary-700">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-flashlight-fill"></i>
                </span>
                当前最热话题
              </div>
              <p className="mt-2 font-heading text-lg font-bold text-foreground-950">吃瓜资料</p>
              <p className="mt-1 text-xs text-foreground-600">近 24 小时新增 320 条，讨论量翻倍</p>
            </div>
            <div className="rounded-xl border border-secondary-200 bg-secondary-50 p-5">
              <div className="flex items-center gap-2 text-xs text-secondary-700">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-cloud-line"></i>
                </span>
                网盘转存技巧
              </div>
              <p className="mt-2 font-heading text-lg font-bold text-foreground-950">失效找回</p>
              <p className="mt-1 text-xs text-foreground-600">提取码失效可在话题墙反馈，平均 2 小时补档</p>
            </div>
            <div className="rounded-xl border border-accent-200 bg-accent-50 p-5">
              <div className="flex items-center gap-2 text-xs text-accent-800">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-image-2-line"></i>
                </span>
                素材内容合集
              </div>
              <p className="mt-2 font-heading text-lg font-bold text-foreground-950">壁纸图库</p>
              <p className="mt-1 text-xs text-foreground-600">4000+ 张双尺寸，每周补充一批新图</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}